import { setReactInputValue, selectFirstReactSelectOption, selectFirstEnabledReactSelectOption, clickTab, openMenuAndGet,} from '../../shared/domHelpers'
import { demoRoutes, setDemoTourResume } from '../DemoFlow'
import demoStore from '../mock/DemoStore'
import { DEMO_IDS } from '../mock/fixtures/mqttPacket'
import { skipStageConfig, DEMO_MONITORADO_PARAMS_TAB_INDEX } from '../demoSkipStage'
import { withNativeDemoSaveAllowed } from '../demoSaveControls'
import { disablePopoverButtons } from '../../tourUi'

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))
const SUCCESS_MODAL_READING_TIME = 600

const LISTA_READY = '[data-tour="monitorado-novo"], [data-tour="monitorado-lista"], [data-tour="help-monitorado-grid"]'
const FORM_READY = '[data-tour="monitorado-form-root"], input[name="nome"]'
const EDIT_READY = '[data-tour="monitorado-form-root"][data-eh-edicao="true"], [data-tour="tab-monitorado-parametros"]'

const getMenuMonitorados = () =>
    openMenuAndGet('equipamento', 'group-equipamento', '[data-tour="menu-monitorados"]')

export const ensureMonitoradoDemoEntities = () => {
    if (!demoStore.state.cliente) {
        demoStore.createCliente({ nome_fantasia: 'Cliente Demonstração' })
    }
    if (!demoStore.state.equipamento) demoStore.createEquipamento()
    if (!demoStore.state.campos.length) {
        demoStore.createCampo({
            identificacao: 'temperatura',
            descricao: 'Temperatura',
            formula: '[temperatura]',
            tipo_grafico: 'linha',
            unidade: '°C',
        })
    }
}

const fillNome = () => {
    const nomeInput =
        document.querySelector('[data-tour="monitorado-nome"] input') ||
        document.querySelector('input[name="nome"]') ||
        document.querySelector('#nome')
    if (nomeInput) setReactInputValue(nomeInput, 'Monitorado Demonstração')
}

const fillCliente = async () => {
    await selectFirstReactSelectOption('[data-tour="monitorado-cliente"]')
}

const fillTipo = async () => {
    await selectFirstReactSelectOption('[data-tour="monitorado-tipo"]')
}

const fillEndereco = () => {
    const addressInput =
        document.querySelector('[data-tour="monitorado-endereco"] input') ||
        document.querySelector('#address') ||
        document.querySelector('input[name="address"]')
    if (addressInput) setReactInputValue(addressInput, 'Av. Paulista, 1000 - São Paulo, SP')
}

const fillAllRequired = async () => {
    fillNome()
    await fillCliente()
    await delay(120)
    await fillTipo()
    fillEndereco()
}

const selecionarParametroDisponivel = () =>
    selectFirstEnabledReactSelectOption('[data-tour="monitorado-param-campo"]', ['Selecionar Todos'])

const vincularParametroCampos = async () => {
    clickTab('[data-tour="tab-monitorado-parametros"]')
    await delay(200)
    await selectFirstReactSelectOption('[data-tour="monitorado-param-equipamento"]')
    await delay(250)
    return selecionarParametroDisponivel()
}

const confirmarVinculoParametro = (parametroSelecionado) => {
    if (parametroSelecionado) {
        document.querySelector('[data-tour="monitorado-param-vincular"]')?.click()
        return
    }

    if (!demoStore.state.monitoradoParametros.length && demoStore.state.campos[0]) {
        demoStore.linkParametro({
            monitorado_id: DEMO_IDS.monitorado,
            campo_id: demoStore.state.campos[0].id,
        })
    }
}

const waitSuccessModal = (tourManager, timeout = 10000) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body, .modal.show .modal-content')
        if (body && /sucesso|criado|editado/i.test(body.textContent || '')) return body
        return null
    }, timeout)

const dismissSuccessWithoutHardReload = () => {
    const modalButtons = Array.from(
        document.querySelectorAll('.modal.show .modal-footer button, .modal.show button')
    )
    const continuar = modalButtons.find((button) =>
        /^continuar$/i.test((button.textContent || '').trim())
    )
    if (continuar) {
        continuar.click()
    }
}

const ensureMonitoradoInStore = () => {
    if (!demoStore.state.monitorado) {
        demoStore.createMonitorado({ nome: 'Monitorado Demonstração' })
    }
}

const goToEditAndResumeParams = async (tourManager) => {
    ensureMonitoradoInStore()

    setDemoTourResume('demo-monitorado', demoRoutes.monitoradoEdit, DEMO_MONITORADO_PARAMS_TAB_INDEX)

    if (tourManager.isActive()) {
        tourManager.destroy()
    }

    const startParams = () => {
        tourManager.start('demo-monitorado', { resumeIndex: DEMO_MONITORADO_PARAMS_TAB_INDEX })
    }

    if (window.location.pathname.includes('/editar')) {
        setTimeout(startParams, 350)
        return
    }

    if (tourManager.history) {
        tourManager.history.push(demoRoutes.monitoradoEdit)
        try {
            await tourManager.waitForElement(EDIT_READY, 8000)
        } catch (error) {}
        setTimeout(startParams, 300)
        return
    }

    window.location.href = demoRoutes.monitoradoEdit
}

const saveMonitoradoAndContinue = async (tourManager) => {
    if (tourManager._hdvSavingMonitorado) return
    tourManager._hdvSavingMonitorado = true
    disablePopoverButtons({ next: true, prev: true })

    try {
        await fillAllRequired()
        await delay(150)

        const saveButton = document.querySelector('[data-tour="monitorado-salvar"]')
        if (saveButton) {
            withNativeDemoSaveAllowed(saveButton, () => saveButton.click())
        }

        try {
            await waitSuccessModal(tourManager)
            await delay(SUCCESS_MODAL_READING_TIME)
        } catch (error) {}

        ensureMonitoradoInStore()
        setDemoTourResume('demo-monitorado', demoRoutes.monitoradoEdit, DEMO_MONITORADO_PARAMS_TAB_INDEX)

        if (document.querySelector('.modal.show')) {
            dismissSuccessWithoutHardReload()
            await delay(300)
        }

        await goToEditAndResumeParams(tourManager)
    } catch (error) {
        ensureMonitoradoInStore()
        setDemoTourResume('demo-monitorado', demoRoutes.monitoradoEdit, DEMO_MONITORADO_PARAMS_TAB_INDEX)
        await goToEditAndResumeParams(tourManager)
    } finally {
        setTimeout(() => {
            tourManager._hdvSavingMonitorado = false
        }, 800)
    }
}

const goToListaMonitoradoDemo = (tourManager) => {
    demoStore.seedThroughStage('monitorado-demo')
    setDemoTourResume('demo-monitorado-demo', demoRoutes.listaMonitorados, 0)
    tourManager.finish('demo-monitorado')

    const startMonitoradoDemo = () => tourManager.start('demo-monitorado-demo', { resumeIndex: 0 })

    if (tourManager.history) {
        tourManager.history.push(demoRoutes.listaMonitorados)
        setTimeout(startMonitoradoDemo, 350)
        return
    }

    window.location.href = demoRoutes.listaMonitorados
}

const buildDemoMonitoradoTourSteps = (tourManager) => [
    {
        element: getMenuMonitorados,
        ensureReady: async () => {
            ensureMonitoradoDemoEntities()

            const modal = document.querySelector('.modal.show')
            if (modal) {
                const continuar = Array.from(modal.querySelectorAll('.modal-footer button, button')).find((button) =>
                    /^continuar$/i.test((button.textContent || '').trim())
                )
                continuar?.click()
                await delay(200)
            }

            const menuItem = getMenuMonitorados()
            if (menuItem) return menuItem
            return tourManager.waitForElement(getMenuMonitorados)
        },
        popover: {
            title: 'Monitorados',
            description: 'No menu, este item abre a lista de monitorados. Último cadastro básico: unimos cliente e equipamento.',
            side: 'right',
            align: 'start',
            onNextClick: () => {
                ensureMonitoradoDemoEntities()
                tourManager.navigateAndWait(demoRoutes.monitoradoLista, LISTA_READY, 1, 'demo-monitorado')
                    .then(() => tourManager.moveNext())
                    .catch(() => tourManager.moveNext())
            },
        },
    },
    {
        element: '[data-tour="monitorado-novo"]',
        ensureReady: () => tourManager.waitForElement(LISTA_READY),
        skipStage: skipStageConfig('monitoradoParams'),
        popover: {
            title: 'Demonstração: Monitorado',
            description: 'Aqui ficam os monitorados cadastrados. Clique em <strong>Próximo</strong> para iniciar o cadastro.<br><br>Clique em <strong>Pular etapa</strong> para finalizar imediatamente esse cadastro e ir para o próximo.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                tourManager.navigateAndWait(demoRoutes.monitoradoNovo, FORM_READY, 2, 'demo-monitorado')
                    .then(() => tourManager.moveNext())
                    .catch(() => tourManager.moveNext())
            },
        },
    },
    {
        element: '[data-tour="monitorado-nome"]',
        ensureReady: () => tourManager.waitForElement('[data-tour="monitorado-nome"] input, input[name="nome"], #nome'),
        popover: {
            title: 'Nome do Monitorado',
            description: 'Dê um nome fácil de reconhecer. É assim que ele aparece na lista, no mapa e nas telas de monitoramento.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                fillNome()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-cliente"]',
        popover: {
            title: 'Cliente',
            description: 'Selecione o cliente responsável por este monitorado. Na demonstração usamos o cliente fictício criado no passo anterior.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                await fillCliente()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-tipo"]',
        popover: {
            title: 'Tipo',
            description: 'O tipo organiza o monitorado e define o ícone e a cor no mapa. Selecionamos o tipo demo disponível.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                await fillTipo()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-endereco"]',
        popover: {
            title: 'Endereço / ponto no mapa',
            description: 'Digite o endereço. O sistema tenta localizar no mapa automaticamente. Se não encontrar, posicione o marcador manualmente.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                fillEndereco()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-mapa"]',
        popover: {
            title: 'Mapa',
            description: 'Clique no mapa ou arraste o marcador para ajustar a localização exata do monitorado. Na demonstração mantemos o ponto já posicionado.',
            side: 'top',
            align: 'center',
            onNextClick: () => tourManager.moveNext(),
        },
    },
    {
        element: '[data-tour="tab-monitorado-parametros"], [data-tour="tab-monitorado-condicoes"]',
        popover: {
            title: 'Outras abas',
            description: 'Parâmetros, Condições, Comandos e Fotos ficam disponíveis somente depois de salvar o monitorado pela primeira vez.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => tourManager.moveNext(),
        },
    },
    {
        element: '[data-tour="monitorado-salvar"]',
        popover: {
            title: 'Salvar',
            description: 'Clique em <strong>Salvar e continuar</strong>. O guia grava o monitorado e abre a edição para vincular parâmetros.',
            side: 'top',
            align: 'end',
            nextBtnText: 'Salvar e continuar',
            onNextClick: () => saveMonitoradoAndContinue(tourManager),
        },
    },
    {
        element: '[data-tour="tab-monitorado-parametros"]',
        ensureReady: async () => {
            ensureMonitoradoDemoEntities()
            ensureMonitoradoInStore()
            if (!window.location.pathname.includes('/editar')) {
                await tourManager.navigateAndWait(
                    demoRoutes.monitoradoEdit,
                    EDIT_READY,
                    DEMO_MONITORADO_PARAMS_TAB_INDEX,
                    'demo-monitorado'
                )
            }
            await tourManager.waitForElement(EDIT_READY, 8000)
        },
        skipStage: skipStageConfig('monitoradoDemoLista'),
        popover: {
            title: 'Aba Parâmetros',
            description: 'Aqui você vincula os parâmetros do equipamento a este monitorado. É o que permite ver dados, gráficos e alertas. Clique em <strong>Próximo</strong> para abrir a aba.<br><br>Clique em <strong>Pular etapa</strong> para finalizar imediatamente esse cadastro e ir para o próximo.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                clickTab('[data-tour="tab-monitorado-parametros"]')
                setTimeout(() => tourManager.moveNext(), 200)
            },
        },
    },
    {
        element: '[data-tour="monitorado-param-equipamento"]',
        ensureReady: async () => {
            clickTab('[data-tour="tab-monitorado-parametros"]')
            await tourManager.waitForElement('[data-tour="monitorado-param-equipamento"]')
        },
        popover: {
            title: 'Equipamento',
            description: 'Escolha o equipamento de onde virão os dados. Na demonstração selecionamos o equipamento MQTT criado no início.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                await selectFirstReactSelectOption('[data-tour="monitorado-param-equipamento"]')
                await delay(200)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-param-campo"]',
        popover: {
            title: 'Parâmetro',
            description: 'Depois de escolher o equipamento, selecione o parâmetro que deseja acompanhar neste monitorado.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                await selecionarParametroDisponivel()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="monitorado-param-vincular"]',
        popover: {
            title: 'Vincular parâmetro',
            description: 'Clique em <strong>Próximo</strong> para associar o parâmetro ao monitorado. A vinculação é salva na hora.',
            side: 'left',
            align: 'start',
            nextBtnText: 'Vincular',
            onNextClick: async () => {
                const parametroSelecionado = await vincularParametroCampos()
                confirmarVinculoParametro(parametroSelecionado)
                await delay(350)
                tourManager.moveNext()
            },
        },
    },
    {
        element: () =>
            document.querySelector('[data-tour="monitorado-param-lista"]') ||
            document.querySelector('[data-tour="monitorado-param-lista-vazia"]') ||
            document.querySelector('[data-tour="monitorado-form-root"]'),
        ensureReady: async () => {
            clickTab('[data-tour="tab-monitorado-parametros"]')

            try {
                await tourManager.waitForElement(() => {
                    const carregando = document.querySelector(
                        '[data-tour="monitorado-param-lista"] .hdv-report-loading'
                    )
                    if (carregando) return null

                    return (
                        document.querySelector('[data-tour="monitorado-param-lista"] tbody tr') ||
                        document.querySelector('[data-tour="monitorado-param-lista-vazia"]')
                    )
                }, 5000)
            } catch (error) {}
        },
        popover: {
            title: 'Parâmetros vinculados',
            description: 'A lista mostra tudo o que já está vinculado. Com parâmetros aqui, o monitorado passa a exibir dados na Lista de Monitorados. Em <strong>Próximo</strong> vamos para essa lista.',
            side: 'top',
            align: 'start',
            nextBtnText: 'Ir para lista',
            onNextClick: () => goToListaMonitoradoDemo(tourManager),
        },
    },
    {
        popover: {
            title: 'Continuando…',
            description: 'Abrindo a Lista de Monitorados…',
            showButtons: ['close'],
        },
    },
]

export default buildDemoMonitoradoTourSteps
